import React, { useState, useEffect, useRef } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import InputBase from '@material-ui/core/InputBase';
import {
  Drawer,
  Typography,
  Grid,
  Paper,
  TableRow,
} from "@material-ui/core";
import DetailTable from "./DetailTable";
import { Link } from "react-router-dom";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import  Style from './manuscript.search.style.js'
import SearchIcon from '@material-ui/icons/Search';
import { useHistory  } from 'react-router';

const drawerWidth = 500;

const useStyles = makeStyles((theme) => ({
  root: {
    top: "304px",
    left: "0px",
    width: "800px",
    minHeight: '2%',
    background: " #FCFCFC 0% 0% no-repeat padding-box",
    border: "1px solid #D8D8D8",
    opacity: 1,
  },
  rootsearch: {
    top: "304px",
    left: "0px",
    width: "800px",
    height: "50px",
    background: " #FCFCFC 0% 0% no-repeat padding-box",
    opacity: 1,
  },
  text: {
    marginTop: "10px",
    marginBottom: '10px',
    marginLeft: "25px",
    textAlign: "left",
    font: "normal normal 600 20px Montserrat",
    letterSpacing: "0px",
    color: "#DC251A",
  },
  card: {
    top: "504px",
    marginLeft: "0px",
    width: "500px",
    height: "70px",
    background: "#FCFCFC 0% 0% no-repeat padding-box",
    border: "0.5px solid #D8D8D8",
    borderRadius: "3px",
    opacity: 1,
  },
  header: {
    top: "91px",
    left: "-0.28125px",
    height: "160px",
    background: "#DC251A 0% 0% no-repeat padding-box",
    boxShadow: "0px 0px 10px #00000033",
    border: "1px solid #D8D8D8",
    borderRadius: "3px",
    opacity: 1,
  },
  backButton: {
    position: "relative",
    top: "15px",
    left: "-100px",
    width: "272px",
    height: "24px",
    textAlign: "left",
    font: "normal normal medium 24px/40px Montserrat",
    letterSpacing: "0px",
    color: "#FFFFFF",
    opacity: 1,
  },
  backButtonText: {
    position: "relative",
    top: "-9px",
    marginLeft: '45px',
    height: "32px",
    textAlign: "left",
    fontSize: " 18px",
    fontFamily: "Montserrat",
    letterSpacing: "0px",
    color: "#FFFFFF",
    opacity: 1,
    
  },
  headerText: {
    position:"relative",
    top: "-5px",
    left: "30px",
    width: "498px",
    height: "79px",
    textAlign: "left",
    justifyContent:"space-evenly",
    font: "normal normal 600 24px Montserrat",
    letterSpacing: "0px",
    color: "#FCFCFC",
    opacity: 1,
  },

  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerOpen: {
    width: drawerWidth,
    overflowX: 'hidden',
    backgroundColor: "#F2F2F2",
  },

  event: {
    fontFamily: 'Montserrat',
    fontSize: '12px',
    color: 'white',
    fontWeight: '200',
    marginLeft: '330px',
    marginTop: '5px', 
    cursor: 'pointer'
  }
}));

const DetailView = (props) => {
  
  const classes = useStyles();
  const classe = Style();
  const ref = useRef(null);
  const [isSearchShow, showSearch] = useState(false);
  const [open, setOpen] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [query, setQuery] = useState("")
  const fromSearchToDetail = (searchData) => {
    setSearchValue(searchData);
  };

  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
        showSearch(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });
  
  // setting filtering logic to have only Documents related to a specific event
  const manuForPlace = props.manuData.filter((el) => {
    return el.latStart === props.dataLat;
  });

  const handleBack = () => {
    props.handleClick();
  };

  const history = useHistory()
  


  return (
    <div>
      {props.manuData.map((el) => {
        if (el.latStart === props.dataLat && el.lngStart === props.dataLong) {
          let eventPlace = el.eventRecord.id.replaceAll("-", " ");
          let place = eventPlace.split(" ");
          let placeName = place[1];

        
          return (
            <div>
              <Drawer
                variant="permanent"
                className={clsx(classes.drawer, {
                  [classes.drawerOpen]: open,
                })}
                classes={{
                  paper: clsx({
                    [classes.drawerOpen]: open,
                  }),
                }}
              >
                <div style={{ width: 500 }}>
                  <Grid container>
                    <Grid>
                      <Paper className={classes.header}>
                        <div style={{marginTop: '10px'}}>
                        <Link style={{textDecoration: "none"}} onClick={handleBack}>
                          <div style={{marginLeft: '10px'}}>
                          <ArrowBackIosIcon className={classes.backButton} />
                          <Typography className={classes.backButtonText}>
                            {" "}
                            Back to {props.countrySelected.slice(0,1).toUpperCase() + props.countrySelected.slice(1)}'s Events 
                          </Typography>
                          </div>
                        </Link>
                        <Typography className={classes.headerText}>
                          
                       {history.location.place.toUpperCase()}'S {place[0]} NEWS <br/> CIRCULATION MAP{" "}
                        <p className={classes.event} onClick={() => history.push(`/tabpanel/${history.location.recordId}`, {place: history.location.place, eventType: history.location.eventType, eventDate: history.location.eventDate, eventDescription: history.location.eventDescription  }) }>Go to Event Page</p>
                        </Typography>
                        </div>
                      </Paper>
                    </Grid>

                    <Grid item container >
                      <Grid item xs={12} className={classes.root}>
                        <Typography className={classes.text}>
                          {manuForPlace.length} Manuscript Sent From{" "}
                          {el.startPoint}
                        </Typography>
                      </Grid>
                    
                 <div className={classes.rootsearch}>
                      <div className={classe.search} style={{float: 'right', marginRight: '23px'}} ref={ref}>
                      <div className={classe.searchIcon} onClick={(e) => { showSearch(!isSearchShow) }}>    
                          <SearchIcon />
                          </div>
                             <InputBase placeholder="Search by place" classes={{
                                  root: classe.inputRoot,
                                  input: isSearchShow ? classe.inputShow : classe.inputHide,
                              }} onChange={event => setQuery(event.target.value)} 
                               autoFocus />
                                
                            
                        
                           </div>
                    </div>
                  
                      <Grid>
                        {
                         manuForPlace.filter(el => {
                          if (query === '') {
                            return el;
                          } else if (el.recipient.toLowerCase().includes(query.toLowerCase())) {
                            return el;
                          } else if (el.dateOfWriting.toLowerCase().includes(query.toLowerCase())) {
                            return el;
                          } else if (el.documentTitle.toLowerCase().includes(query.toLowerCase())) {
                            return el;
                          } else if  (el.author.toLowerCase().includes(query.toLowerCase())) {
                            return el;
                          } else if  (el.language.toLowerCase().includes(query.toLowerCase())) {
                            return el;
                           }
                          }
                        ).map((el, index) => (
                          <div key={index}>
                          <TableRow>
                            <DetailTable manuscript={el} />
                          </TableRow>
                          </div>
                        ))}
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </Drawer>
            </div>
          );
        }
      })}
    </div>
  );

  // return (
  //   <div>
  //   {props.manuData.map((el) => {

  //       if (el.latStart === props.dataLat && el.lngStart === props.dataLong){
  //           return (
  //               <div>{el.startPoint}</div>
  //           )
  //       }
  //   } )}
  //   </div>
  // )
};

export default DetailView;
